// Network status middleware for Redux
import { message } from 'antd';

let offlineActionQueue = [];

const networkMiddleware = store => next => action => {
  if (action.type === 'network/statusChanged') {
    const { isOnline } = action.payload;
    
    // Use notification instead of message for network status
    if (isOnline) {
      setTimeout(() => {
        message.success({
          content: 'You are back online!',
          key: 'network-status',
          duration: 3
        });
        
        if (offlineActionQueue.length > 0) {
          message.info({
            content: `Syncing ${offlineActionQueue.length} pending changes...`,
            key: 'sync-status',
            duration: 2
          });
          
          offlineActionQueue.forEach(queuedAction => {
            store.dispatch(queuedAction);
          });
          
          offlineActionQueue = [];
        }
      }, 0);
    } else {
      setTimeout(() => {
        message.warning({
          content: 'You are offline. Changes will be saved locally and synced when you reconnect.',
          key: 'network-status',
          duration: 4
        });
      }, 0);
    }
  }
  
  if (action.meta?.requiresNetwork && !navigator.onLine) {
    offlineActionQueue.push(action);
    
    setTimeout(() => {
      message.info({
        content: 'Action saved for when you reconnect',
        duration: 2
      });
    }, 0);
    
    return next({
      type: `${action.type}_OFFLINE_QUEUED`,
      payload: action.payload,
      meta: { ...action.meta, offlineQueued: true }
    });
  }
  
  return next(action);
};

export default networkMiddleware;